// Module
var code = "<template show.bind=\"visible\" class=\"ess-dropdown z-depth-1 ${state | hasFlag: OpenFlags.Closed | toggle: 'ess-closed'} ${asDirectionClass(direction)}\" css=\"max-height: ${maxHeight};\" element.ref=\"$container\" tabindex=\"-1\" focusout.delegate=\"handleFocusout($event)\" ess-capture-focus> <slot></slot> </template> ";
// Exports
module.exports = code;